// Single source of truth for the AI model catalog shown in the UI.
// Version numbers drive provider routing in src/ai/api/index.js
// (< 10 = OpenAI, < 15 = Gemini, >= 15 = Claude).
export const AI_MODELS = [
  { name: 'OpenAI GPT-4.1', version: 5 },
  { name: 'OpenAI GPT-5.4 Mini', version: 6 },
  { name: 'OpenAI GPT-5.5', version: 7 },
  { name: 'Gemini 3.5 Flash', version: 11 },
  { name: 'Gemini 3.1 Pro', version: 12 },
  { name: 'Claude Sonnet 4.6', version: 15 },
  { name: 'Claude Opus 4.8', version: 16 },
  { name: 'Claude Haiku 4.5', version: 17 }
]

// Map a raw model id (as stored on usage rows, e.g. a Bedrock inference-profile id
// like 'eu.anthropic.claude-sonnet-4-6', or a provider id like 'gemini-3.1-pro-preview')
// to the friendly catalog name shown in the model dropdown. Usage charts group by the
// raw id, which is long, provider/region-prefixed, and clips in narrow labels. Unknown
// ids fall back to the id with any provider/region prefix stripped.
const MODEL_LABEL_RULES = [
  { match: /claude.*sonnet.*4.?6/i, name: 'Claude Sonnet 4.6' },
  { match: /claude.*opus.*4.?8/i, name: 'Claude Opus 4.8' },
  { match: /claude.*haiku.*4.?5/i, name: 'Claude Haiku 4.5' },
  { match: /gemini.*3\.?5.*flash/i, name: 'Gemini 3.5 Flash' },
  { match: /gemini.*3\.?1.*pro/i, name: 'Gemini 3.1 Pro' },
  { match: /gpt.*4\.?1/i, name: 'OpenAI GPT-4.1' },
  { match: /gpt.*5\.?4.*mini/i, name: 'OpenAI GPT-5.4 Mini' },
  { match: /gpt.*5\.?5/i, name: 'OpenAI GPT-5.5' }
]

export const modelDisplayName = (rawId) => {
  if (!rawId) {
    return 'Unknown'
  }
  const hit = MODEL_LABEL_RULES.find((rule) => rule.match.test(rawId))
  if (hit) {
    return hit.name
  }

  // Unknown model — strip a leading provider/region prefix so it at least reads cleanly.
  return String(rawId).replace(/^(eu|us|apac)\.anthropic\./i, '').replace(/^anthropic\./i, '')
}
